import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type DigiKeyV4LocaleSiteDTO = z.infer<typeof DigiKeyV4LocaleSiteDTORuntype>;
export const DigiKeyV4LocaleSiteDTORuntype = z.enum([
    'UnitedStatesOfAmerica',
    'Canada',
    'Japan',
    'UnitedKingdom',
    'Germany',
    'Austria',
    'Belgium',
    'Denmark',
    'Finland',
    'Greece',
    'Ireland',
    'Italy',
    'Luxembourg',
    'Netherlands',
    'Norway',
    'Portugal',
    'Spain',
    'SouthKorea',
    'HongKong',
    'Singapore',
    'China',
    'Taiwan',
    'Australia',
    'France',
    'India',
    'NewZealand',
    'Sweden',
    'Mexico',
    'Switzerland',
    'Israel',
    'Poland',
    'Slovakia',
    'Slovenia',
    'Latvia',
    'Lithuania',
    'Estonia',
    'CzechRepublic',
    'Hungary',
    'Bulgaria',
    'Malaysia',
    'SouthAfrica',
    'Romania',
    'Thailand',
    'Philippines',
]);

export type DigiKeyV4LocaleCurrencyDTO = z.infer<typeof DigiKeyV4LocaleCurrencyDTORuntype>;
export const DigiKeyV4LocaleCurrencyDTORuntype = z.enum([
    'USD',
    'CAD',
    'JPY',
    'GBP',
    'EUR',
    'HKD',
    'SGD',
    'TWD',
    'KRW',
    'AUD',
    'NZD',
    'INR',
    'DKK',
    'NOK',
    'SEK',
    'ILS',
    'CNY',
    'PLN',
    'CHF',
    'CZK',
    'HUF',
    'RON',
    'ZAR',
    'MYR',
    'THB',
    'PHP',
]);

export interface DigiKeyV4LocaleDTO extends z.infer<typeof DigiKeyV4LocaleDTORuntype> {}
export const DigiKeyV4LocaleDTORuntype = z.object({
    site: DigiKeyV4LocaleSiteDTORuntype,
    currency: DigiKeyV4LocaleCurrencyDTORuntype,
});

export type DigiKeyV4AccountIdDTO = z.infer<typeof DigiKeyV4AccountIdDTORuntype>;
export const DigiKeyV4AccountIdDTORuntype = z.union([z.number(), z.null()]);

export interface DigiKeyV4CredentialsDTO extends z.infer<typeof DigiKeyV4CredentialsDTORuntype> {}
export const DigiKeyV4CredentialsDTORuntype = z.object({
    client_id: z.string(),
    client_secret: z.string(),
    locale: DigiKeyV4LocaleDTORuntype,
    account_id: DigiKeyV4AccountIdDTORuntype,
});

export interface DigiKeyV4ResponseBodyDTO extends z.infer<typeof DigiKeyV4ResponseBodyDTORuntype> {}
export const DigiKeyV4ResponseBodyDTORuntype = z.object({
    data: DigiKeyV4CredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
